import { ILocalScheme } from 'src/types/local';

export const enum EStages {
  local = 'local',
  development = 'development',
  test = 'test',
  mock = 'mock',
  uat = 'uat',
  production = 'production',
}

export const APP_LK_SICK_HOST = process.env.REACT_APP_LK_SICK_HOST;
export const APP_LK_EMPLOYEE_HOST = process.env.REACT_APP_LK_EMPLOYEE_HOST;

let localScheme: ILocalScheme | undefined;

try {
  localScheme = JSON.parse(
    String(process.env.REACT_APP_LOCAL_SCHEME),
  ) as ILocalScheme;
} catch {
  //
}

export const APP_LOCAL_SCHEME = localScheme;
export const APP_API_URL = process.env.REACT_APP_LK_API_SERVER_URL;
export const APP_AUTH_SERVER_URL = process.env.REACT_APP_LK_AUTH_SERVER_URL;
export const APP_COMMIT = process.env.REACT_APP_LK_COMMIT ?? 'no commit';
export const USER_SPECIAL_TOKEN = process.env.REACT_APP_LK_USER_AUTH_TOKEN;
export const APP_API_URL_MOCK = process.env.REACT_APP_LK_API_SERVER_URL_MOCK;
export const IS_DEBUG = process.env.REACT_APP_LK_DEBUG === 'true';
export const APP_LK_ENV = process.env.REACT_APP_LK_ENV;
export const APP_LK_BRANCH = process.env.REACT_APP_LK_BRANCH;
export const APP_LK_STAGE = process.env.REACT_APP_LK_STAGE as EStages;
export const APP_SENTRY_ENABLED =
  process.env.REACT_APP_SENTRY_ENABLED === 'true';
export const APP_SENTRY_URL = process.env.REACT_APP_SENTRY_URL;

export const NEW_NOTIFICATIONS_WIDGET =
  process.env.REACT_APP_NEW_NOTIFICATIONS_WIDGET === 'true';

export const config = {
  devEmail: 'Dev_LKE@beeline.ru',
  supportEmail: 'Help_LKE@beeline.ru',
};

export const APP_ANALYTICS_ID = process.env.REACT_APP_ANALYTICS_ID;
export const APP_HELPDESK_WIDGET_URL =
  process.env.REACT_APP_HELPDESK_WIDGET_URL;

export const APP_IDP_SERVER_URL = process.env.REACT_APP_IDP_SERVER_URL;
export const APP_IDP_CLIENT_ID = process.env.REACT_APP_IDP_CLIENT_ID;

export const APP_CHATBOT_URL = process.env.REACT_APP_CHATBOT_URL;
export const APP_CHATBOT_CHANNEL_TOKEN =
  process.env.REACT_APP_CHATBOT_CHANNEL_TOKEN;

export const APP_MYPROFILE_SERVER_URL =
  process.env.REACT_APP_MYPROFILE_SERVER_URL;
